import BlogPost from "pages/MyBlogs/blogpost";

export default function() {
    return <BlogPost/>
}